var styles = {
  "underlay": "pb-Loading__underlay",
  "dialog": "pb-Loading__dialog",
  "dialogContent": "pb-Loading__dialogContent",
  "fade": "pb-Loading__fade",
  "fade--entered": "pb-Loading__fade--entered",
  "logo": "pb-Loading__logo",
  "children": "pb-Loading__children",
  "icon": "pb-Loading__icon",
  "spin": "pb-Loading__spin"
};
export default styles;